module.exports = __webpack_public_path__ + "static/media/britta aakar ma click garau.946c3e61.wav";